import _ from 'lodash';
import { post } from './agent';
import feedbackItemFiles from './feedbackItemFiles';

const feedbackItems =
  (workspacesUrl) =>
  (id = '') => {
    const url = _([workspacesUrl, 'feedback-items', id]).compact().join('/');

    return {
      files: feedbackItemFiles(url.concat('/files')),
      create: (body) => post(url, body),
    };
  };

export default feedbackItems;
